import "./supplychain.css";
import Footer from "../components/Footer";

import Navbar from "../components/Navbar";
const Smart = () => {

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>
      {/* Smart Inventory Section */}

      <div className="supply-container">
        <div className="supply-header">
          <h1 className="supply-title">
            No More Guessing, Manage Stock Smarter{" "}
          </h1>
          <p className="supply-description">
            We help you stay on top of your stock—no stress, no guesswork. With
            real-time tracking and smart insights, you won’t overstock, run out
            of products, or waste money on extra storage. It’s all about making
            inventory easy to manage, knowing what you’ll need ahead of time,
            and refilling just when you need to.
          </p>
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="smart1.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>CUT LABOR COST BY 30% OF AUTOMATION</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Save 25-30% on manual labour through Automated Inventory Tracking.
          </h4>
          <ul className="featuresSupply">
            <li>Team spend less time in searching item to fulfil order.</li>
            <li>Reducing the reliance on costly, unplanned repair.</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h1>INCREASE ORDER FULFILLMENT SPEED BY 30%</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Enhance logistics efficiency by 40% using smart warehousing
            solution.{" "}
          </h4>
          <ul className="features">
            <li>Quickly locate and fulfil rush order</li>
            <li>Impress clients with prompt service.</li>
          </ul>
        </div>
        <div className="image-section">
          <img src="smart2.png" alt="Product Line" />
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="smart3.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>ACHEIVE 98% ACCURACY IN INVENTORY SORTING</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Reduce operational error by 60% with precise Automated System.
          </h4>
          <ul className="featuresSupply">
            <li>
              Avoid the frustration of misplaced productsduring Rush hour.
            </li>
            <li>Reducing the reliance on costly, unplanned repair.</li>
          </ul>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Smart;
